import React, {useEffect, useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Button from '@material-ui/core/Button';
import {ConfirmDialog, MaterialTable, PageHeader} from "../../components";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import api from "../../common/api";
import Icon from "@material-ui/core/Icon";
import NewShed from './components/shed';
import Mobile from "./components/mobile";
import { useGlobalState } from '../../state';
import { updateOnboardingTaskStatus } from '../../common/functions';
import palette from '../../theme/palettes/default';
import ArrowUpwardIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowDownwardIcon from '@material-ui/icons/KeyboardArrowDown';
import { MTableBodyRow } from 'material-table';


const useStyles = makeStyles(theme => ({
    root: props=>({
        // margin: props.isDesktop?theme.spacing(4):theme.spacing(1),
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    progressBar: {
        margin: theme.spacing(2)
    },
    breadcrumbs:{
        marginBottom: theme.spacing(2)
    },
    link: {
        display: 'flex',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    editOrderButton: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    addShedButton: {
        marginTop: theme.spacing(2),
    },
    cancelOrderButton: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        color: `${palette.background.paper}`,
        backgroundColor:  `${palette.buttonBackground.secondary}`,
        '&:hover': {
            backgroundColor:`${palette.buttonBackground.secondaryHover}`,
        },
    },
    saveOrderButton: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
        color: `${palette.background.paper}`,
        backgroundColor:  `${palette.buttonBackground.primary}`,
        '&:hover': {
            backgroundColor:`${palette.buttonBackground.primaryHover}`,
        },
    },
}));

let currentData = undefined;
let editMode = false;
const Shed = ({showError, showMessage, match}) => {
    const [{user}, dispatch] = useGlobalState();
    const farmID = match.params['farmID'];

    const [loading, setLoading] = useState(false);

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({isDesktop});
    const [sheds, setShed] = useState([]);
    const [showShedDialog, setShowShedDialog] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [shedType, setShedType] = useState([]);
    const [errorMessage, setErrorMessage] = useState('')
    const [editOrder, setEditOrder] = useState(false)
    const [tempSheds, setTempSheds] = useState([]) // for order saving
    const [orderUpdated, setOrderUpdated] = useState(false)

    const handleShedClose = () => {
        currentData = undefined;
        setShowShedDialog(false);
    };

    const onShedEdit = (shed) => {
        currentData = {...shed,
            shedTypeIndex:shedType.findIndex((type)=>{return type.id === shed.shedTypeID;}),
        };;
        editMode = true;
        setShowShedDialog(true);
    };

    function onNewShed(event) {
        editMode = false;
        event.preventDefault();
        removeErrorMessage();
        setShowShedDialog(true);
    };

    const onDelete = (data) => {
        currentData = data;
        setShowDeleteConfirm(true);
    };

    const removeErrorMessage = value =>{
        setErrorMessage('');
    }

    function handleDeleteConfirmClose() {
        setShowDeleteConfirm(false);
    }

    const moveRow = (index, direction) => {
        const newIndex = index + direction;
        if (newIndex < 0 || newIndex >= tempSheds.length) return;
        const updatedSheds = [...tempSheds];
        const [movedItem] = updatedSheds.splice(index, 1);
        updatedSheds.splice(newIndex, 0, movedItem);
        setTempSheds(updatedSheds.map((shed, idx) => ({ ...shed, orderID: idx + 1 })));
        setOrderUpdated(JSON.stringify(updatedSheds) !== JSON.stringify(sheds));
    };

    // Reorder by dragging: move row from source index to destination index
    const reorderRow = (fromIndex, toIndex) => {
        if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return;
        if (fromIndex >= tempSheds.length || toIndex >= tempSheds.length) return;
        const updated = [...tempSheds];
        const [moved] = updated.splice(fromIndex, 1);
        updated.splice(toIndex, 0, moved);
        const withOrder = updated.map((shed, idx) => ({ ...shed, orderID: idx + 1 }));
        setTempSheds(withOrder);
        setOrderUpdated(JSON.stringify(withOrder) !== JSON.stringify(sheds));
    };
    
    const toggleShedOrderEdit = () => {
        setEditOrder(prev => !prev);
        setOrderUpdated(false);
        setTempSheds([...sheds]);
    };
    
    const handleShedOrderCancel = () => {
        setEditOrder(false);
        setTempSheds([...sheds]);
        setOrderUpdated(false);
    };
    
    const handleShedOrderSave = () => {
        setLoading(true);
        const response = api.post(`farm/${farmID}/shed_order`, 
            tempSheds.map((shed, index) => ({ 
                id: shed.id, 
                orderID: index + 1 
            }))
        );
        response.then(() => {
            setShed([...tempSheds]);
            setEditOrder(false);
            setOrderUpdated(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Shed order not saved');
                else
                    setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    }

    const onShedSave = (shed) => {
        setLoading(true);
        // showError('');
        showMessage('');
        const response = api.post(`farm/${farmID}/shed`, {
            ...shed
        });

        response.then(res => {
            //console.debug("shed",shed,res)
            // get all onboardingTasks and update if it is the first shed
            updateOnboardingTaskStatus(user, dispatch, "ADD_SHED", farmID);

            setShed([...sheds, res]);
            setShowShedDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Shed not added');
                else if(err.message ===  'Duplicate Key')
                setErrorMessage('Duplicate Name');
                else
                setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const onShedUpdate = (shed) => {
        setLoading(true);
        // showError('');
        const response = api.post(`farm/${farmID}/shed/${shed.id}`, {
            ...shed
        });
        response.then(() => {
            let index = sheds.findIndex((srcData) => {
                return srcData.id === shed.id;
            });
            setShed([...sheds.slice(0, index),
                {...shed},
                ...sheds.slice(index + 1)]);
            setShowShedDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                setErrorMessage('Shed not updated');
                else if(err.message ===  'Duplicate Key')
                setErrorMessage('Duplicate Name');
                else
                setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    function onDeleteConfirm (){
        if (currentData && currentData.id) {
            setShowDeleteConfirm(false);
            setLoading(true);
            showError('');
            const response = api.delete(`farm/${farmID}/shed/${currentData.id}`);

            response.then(res => {
                if (res) {
                    let index = sheds.findIndex((src) => {
                        return src.id === currentData.id;
                    });
                    let newData = [...sheds];
                    newData.splice(index, 1);
                    setShed(newData);
                }
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        showError('Shed not Deleted');
                    else
                        showError(err.message)
                } else {
                    showError('Unknown Error')
                }
            }).finally(() => {
                setLoading(false);
                currentData = undefined;
            });

        }
    }

    //Get all Shed API Call
    const getAllSheds = () => {
        showError('');
        showMessage('');

        const response = api.get(`farm/${farmID}/shed`);

        response.then(res => {
            setShed([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Sheds');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });

        return response;
    }

    //Get all Shed Type API Call
    const getAllShedType = () => {
        showError('');
        showMessage('');

        const response = api.get(`farm/${farmID}/shed_type`);

        response.then(res => {
            setShedType([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Sheds Type');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });

        return response;
    };

    const getAllData = ()=>{
        setLoading(true);
        Promise.all([getAllSheds(),getAllShedType()]).finally(()=>{
            setLoading(false);
        });
    }
    
    useEffect(getAllData, []);

    let shedColumnDefaults = {title: 'Name',field: 'name', sorting: !editOrder};
    let shedColumn = {...shedColumnDefaults,
        render: rowData => <Mobile data={rowData}
                                   onEdit={()=>{onShedEdit(rowData)}}
                                   onDelete={()=>{onDelete(rowData)}}
                                   editOrder={editOrder}
                                   moveRow={moveRow}
                                   index={rowData.tableData.id}
        />,
        // Other columns are hidden on mobile, and material-table skips hidden columns when searching
        customFilterAndSearch: (term, rowData) => {
            const values = [
                rowData.orderID,
                rowData.name,
                rowData.shedTypeName,
            ];
            return values.some(value => value !== undefined && value !== null &&
                String(value).toLowerCase().includes(term.toLowerCase()));
        },
    };
    let actions = [];
    if (isDesktop) {
        shedColumn = shedColumnDefaults;
        actions = [
            {
                icon: () => <Icon color='primary'>edit</Icon>,
                tooltip: 'Edit Shed',
                onClick: (event, rowData) => {
                    onShedEdit(rowData);
                }
            },
           {
                icon: () => <Icon color='error'>delete</Icon>,
                tooltip: 'Delete Shed',
                onClick: (event, rowData) => {
                    onDelete(rowData);
                }
            }
        ]
    }
    return (
        <div className={classes.root}>
            <PageHeader
                title='Sheds'
                actions={[
                    ...(editOrder ? [
                        { label: 'Save Order', icon: <SaveIcon />, onClick: handleShedOrderSave, variant: 'contained', color: 'primary', disabled: !orderUpdated },
                        { label: 'Cancel Order', icon: <CloseIcon />, onClick: handleShedOrderCancel, variant: 'outlined', color: 'primary' },
                    ] : [
                        { label: 'Edit Order', icon: <SwapVertIcon />, onClick: toggleShedOrderEdit, variant: 'outlined', color: 'primary' },
                    ]),
                    { label: 'Add Shed', icon: <AddCircleIcon />, onClick: onNewShed, variant: 'contained', color: 'primary' },
                ]}
            />
                <MaterialTable

                    isLoading={loading}
                    columns={[
                        {title: 'id', field: 'id', hidden: true, sorting: !editOrder},
                        {title: 'S. No', field: 'orderID', sorting: true, hidden: !isDesktop},
                        shedColumn,
                        {
                            title: "Edit Order",
                            render: rowData => (
                                <div>
                                    <Button onClick={() => moveRow(rowData.tableData.id, -1)}><ArrowUpwardIcon /></Button>
                                    <Button onClick={() => moveRow(rowData.tableData.id, 1)}><ArrowDownwardIcon /></Button>
                                </div>
                            ),
                            hidden: (!isDesktop || !editOrder)
                        },
                        {title: 'Shed Type', field: 'shedTypeName', hidden: !isDesktop, sorting: !editOrder},
                    ]}
                    data={editOrder ? tempSheds : sheds}
                    components={editOrder ? {
                        Row: (rowProps) => {
                            const rowIndex = rowProps?.data?.tableData?.id ?? 0;
                            const handleDragStart = (e) => {
                                e.dataTransfer.setData('text/plain', String(rowIndex));
                                e.dataTransfer.effectAllowed = 'move';
                                // show grabbing cursor while dragging
                                if (e.currentTarget) e.currentTarget.style.cursor = 'grabbing';
                            };
                            const handleDragOver = (e) => {
                                e.preventDefault();
                                e.dataTransfer.dropEffect = 'move';
                            };
                            const handleDrop = (e) => {
                                e.preventDefault();
                                const from = parseInt(e.dataTransfer.getData('text/plain'));
                                const to = rowIndex;
                                reorderRow(from, to);
                            };
                            const handleDragEnd = (e) => {
                                // reset to grab on drag end
                                if (e.currentTarget) e.currentTarget.style.cursor = 'grab';
                            };
                            return (
                                <MTableBodyRow
                                    {...rowProps}
                                    style={{ cursor: 'grab', ...(rowProps.style || {}) }}
                                    draggable
                                    onDragStart={handleDragStart}
                                    onDragOver={handleDragOver}
                                    onDrop={handleDrop}
                                    onDragEnd={handleDragEnd}
                                />
                            );
                        }
                    } : undefined}
                    options={{
                        actionsColumnIndex: -1,
                        search: !editOrder,
                        showTitle: true,
                        toolbar: true,
                        paging: false,
                        sorting: !editOrder,
                        header: isDesktop,
                    }}
                    actions={actions}
                    title={editOrder ? "Edit Order" : "Sheds"}
                />           
            <NewShed deleteErrorMessage={removeErrorMessage} errorMessage={errorMessage} showDialog={showShedDialog} handleClose={handleShedClose} onSave={onShedSave}
                  onEdit={onShedUpdate} shedType = {shedType} 
                  editMode={editMode} data={currentData}/>
             <ConfirmDialog showDialog={showDeleteConfirm}
                       handleClose={handleDeleteConfirmClose}
                       onConfirm={onDeleteConfirm}
                       title='Delete Shed ?'
                       subText='This action will delete the shed.'/>
        </div>
    );
};

export default Shed;